import { render, staticRenderFns } from "./CambioStatoInMassa.vue?vue&type=template&id=6c857e34"
import script from "./CambioStatoInMassa.vue?vue&type=script&lang=js"
export * from "./CambioStatoInMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports